import { useEffect, useState } from 'react';
import { baseurladdress } from '../baseurl';
import axios from 'axios';
import { Modal, Button, ModalHeader, ModalFooter, ToggleButton } from "react-bootstrap";
import { Form, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";


export default function Group({ role }) {

    const Swal = require('sweetalert2');
    const [data, setData] = useState([]);
    const [showModal, setShow] = useState(false);
    const [ERoles, setERoles] = useState(false);
    const { role_id } = useParams();

    const navigate = useNavigate();

    const [role_name, setrole_name] = useState("");
    const [role_description, setrole_description] = useState("");
    const [role_status, setrole_status] = useState("");
    const [x, setX] = useState("");
    const [xy, setXY] = useState("");
    const [roleid, setid] = useState("");

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");

    const [customDropdown, setCustomDropdown] = useState(" ");
    const [customDropdownCheck, setCustomDropdownCheck] = useState(" ");

    //    List Page
    const GetAllRoles = () => {
        axios
            .get(baseurladdress + `findallroles`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then(res => {
                const datas = res.data.response;
                console.log(datas)

                // alert(datas);
                const user = datas.map((item, index) => (

                    <tr  id={"chk" + item.role_id} >
                        <td>{index + 1}</td>
                        <td>{item.role_name}</td>
                        { /*<td>{item.role_description}</td>*/}
                        <td>
                            {item.role_description
                                ?.split('\n')
                                .filter(line => line.trim())
                                .map((line, index) => (
                                    <div key={index}>
                                        -> {line.replace(/^•\s*/, '').trim()}
                                    </div>
                                ))}
                        </td>
                        <td >        <div>
                            {(() => {
                                if (item.role_status == 1) {
                                    return (
                                        <div>
                                            <span class="badge bg-success" >
                                                Active
                                            </span>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div>
                                            <span class="badge bg-danger" >
                                                Inactive
                                            </span>
                                        </div>
                                    );
                                }
                            })()}
                        </div></td>
                        <td>
                            <a>

                                <i class="text-primary fa fa-edit color-muted" onClick={() => handleRoles(item.role_id)} ></i>

                            </a>
                        </td>
                        <td style={{ textAlign: "center" }}>
                            <i class="text-danger fa fa-trash color-danger" onClick={() => deleteroles(item.role_id)}></i>
                        </td>


                    </tr>
                ));

                setData(user);
            })
            .catch(error => {
                alert(error);
            })
    }
    useEffect(() => {
        GetAllRoles();
    }, [role]);

    //CANCEL
    const close = (event) => {
        event.preventDefault();
        setShow(false);
    }
    // MODALBOX
    const changefile = (data) => {
        setShow(true);
    }

    // Edit
    const handleRoles = (role_id) => {
        console.log("role_id+" + role_id);
        setERoles(true);
        axios
            .get(baseurladdress + `editroles/` + role_id, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response;
                console.log("rolesedit+" + data);
                setid(role_id)
                setrole_name(data[0].role_name);
                setrole_description(data[0].role_description);
                setrole_status(data[0].role_status);
                setXY(data[0].role_status);
                const check = (data[0].role_status == "1") ? true : false;
                setX(check);
                setCustomDropdown(data[0].role_cdrpdwn);
                const dropdownCheck = (data[0].role_cdrpdwn == "1") ? true : false;
                setCustomDropdownCheck(dropdownCheck);
            });
    }

    //   Update
    const handleUpdate = (e) => {
        e.preventDefault();
        const data = {
            role_name: role_name,
            role_description: role_description,
            role_status: role_status,
            role_updby: accessuserid,
            role_cdrpdwn:customDropdown,
        };
        axios.put(`${baseurladdress}updateroles/${roleid}`, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }).then((response) => {
            const result = response.data; // Accessing the data from the response
            if (result.status === "updated") {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 800,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });
                Toast.fire({
                    icon: 'success',
                    title: 'Edited Successfully'
                });
                setERoles(false);
                GetAllRoles();
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 800,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });
                Toast.fire({
                    icon: 'error',
                    title: 'Something went wrong'
                });
            }
        }).catch((error) => {
            console.error("Error updating role:", error);
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 800,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            Toast.fire({
                icon: 'error',
                title: 'Something went wrong'
            });
        });
    };

    // Delete
    // function deleteroles(role_id) {
    //     if (
    //         window.confirm(
    //             "Are you sure you want to delete this data? This cannot be undo later."
    //         )
    //     ) {
    //         fetch(baseurladdress + `deleteroles/${role_id}`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json; charset=UTF-8",
    //                 Authorization: `Bearer ${accesstoken}`,
    //             },
    //         }).then((response) => {
    //             if (response.status === 200) {
    //                 $("#chk" + role_id).fadeOut(200, function () { $(this).css('display', 'none'); });
    //                 const Toast = Swal.mixin({
    //                     toast: true,
    //                     position: 'top-end',
    //                     showConfirmButton: false,
    //                     timer: 800,
    //                     timerProgressBar: true,
    //                     didOpen: (toast) => {
    //                         toast.addEventListener('mouseenter', Swal.stopTimer)
    //                         toast.addEventListener('mouseleave', Swal.resumeTimer)
    //                     }
    //                 })
    //                 Toast.fire({
    //                     icon: 'success',
    //                     title: 'Deleted Successfully'
    //                 })
    //             }

    //         });
    //     }
    // };


    function deleteroles(role_id) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                {
                    axios
                        .post(baseurladdress + `deleteroles/` + role_id, data, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                        })
                        .then((response) => {
                            if (response.status === 200) {
                                $("#chk" + role_id).fadeOut(200, function () { $(this).css('display', 'none'); });
                                const Toast = Swal.mixin({
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 800,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener('mouseenter', Swal.stopTimer)
                                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                                    }
                                })
                                Toast.fire({
                                    icon: 'success',
                                    title: 'Deleted Successfully'
                                })
                            }

                        });
                }
            }
        });
    }

    $(function () {
        setTimeout(function () {
            $('#rolelist').DataTable();
        }, 1000);
    });



    const handleDescriptionChange = (e) => {
        let value = e.target.value;

        // Add bullet at beginning
        if (value.length === 1 && value !== "•") {
            value = "• " + value;
        }

        setrole_description(value);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            const start = e.target.selectionStart;
            const end = e.target.selectionEnd;

            const newText =
                role_description.substring(0, start) +
                "\n• " +
                role_description.substring(end);

            setrole_description(newText);

            setTimeout(() => {
                e.target.selectionStart = e.target.selectionEnd =
                    start + 3;
            }, 0);
        }
    };

    return (
        <>
            <div className="card">

                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered table-responsive-sm" id='rolelist'>
                            <thead>
                                <tr>
                                    <th >Sl.No</th>
                                    <th >Role Name</th>
                                    <th >Description</th>
                                    <th>Status</th>
                                    <th >Edit</th>
                                    <th >Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data}
                            </tbody>
                        </table>
                    </div>

                    <Modal className="modal-size md modal-top-center" show={ERoles} style={{ display: "flex" }}>
                        <Modal.Header>
                            <h6>Edit Role</h6>
                            <span
                                aria-hidden="true"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setERoles(false);
                                }}
                            >
                                ×
                            </span>
                        </Modal.Header>
                        <Modal.Body className="css">
                            <form >
                                <div className='row'>
                                    <div className='col-md-9'>
                                        <h6>Roles</h6>
                                        <input type="text" className="form-control" value={role_name}
                                            onChange={(e) => setrole_name(e.target.value)}
                                        /></div>
                                    <div class="col-md-3">
                                        <br />
                                        <input type="checkbox" name="role_status" className="selectsingle checku" checked={x} value={xy} id="exampleCheck1"
                                            onClick={() => { setX(!x); }}
                                            onChange={(event) => {
                                                var checked = event.target.checked; if (checked == true) { setrole_status(1); }
                                                else { setrole_status(0); }
                                            }} /><label className="form__label textal offset-1" for="clienttype">
                                            Status
                                        </label>
                                    </div>
                                </div>
                                {/*   <div>
                                      <h6>Description</h6>
                                    <textarea className="form-control" style={{ height: '200px' }} value={role_description} onChange={(e) => setrole_description(e.target.value)} ></textarea>
                                </div>*/}
                                <textarea
                                    className="form-control"
                                    style={{ height: '200px' }}
                                    value={role_description}
                                    onChange={handleDescriptionChange}
                                    onKeyDown={handleKeyDown}
                                />
                                <div className="col-md-3 d-flex align-items-center mt-2">
                                    <input
                                        type="checkbox"
                                        name="custom_dropdown"
                                        className="selectsingle checku"
                                        checked={customDropdownCheck}
                                        value={customDropdown}
                                        id="customDropdownCheck"
                                        onClick={() => { setCustomDropdownCheck(!customDropdownCheck); }}
                                        onChange={(event) => {
                                            var checked = event.target.checked;
                                            if (checked === true) {
                                                setCustomDropdown(1);
                                            } else {
                                                setCustomDropdown(0);
                                            }
                                        }}
                                    />
                                    <label
                                        className="form__label mb-0 ml-2"
                                        htmlFor="customDropdownCheck"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Custom Dropdown
                                    </label>
                                </div>

                            </form>
                        </Modal.Body>
                        <ModalFooter>
                            <div className="row w-100">
                                <div className="col-auto ml-auto">

                                    <button type="button" className="btn btn-primary ml-2" onClick={handleUpdate}>
                                        Update
                                    </button>
                                </div>
                            </div>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        </>
    )
}
